// List of main sections (components) in the portfolio.
export const components = [
    'Welcome', 'Employment', 'Education', 'Projects', 'Social'
]